import { useState } from 'react';
import { HeartIcon } from '../../assets/icons';
import { LoginImg } from '../../assets/images';
import { Login, Signup } from './components';
import './Auth.scss';

const Auth = () => {
  const [isLogin, setIsLogin] = useState(false);

  return (
    <div className="auth">
      <div className="auth__left">
        <LoginImg />
      </div>

      <div className="auth__right">
        {isLogin ? (
          <Login changeAuth={() => setIsLogin(false)} />
        ) : (
          <Signup changeAuth={() => setIsLogin(true)} />
        )}

        <p className="note">
          <span>Built with </span>
          <HeartIcon />
          <span> by TIP</span>
        </p>
      </div>
    </div>
  );
};

export default Auth;
